export * from './StoveIcon'
